import Client from 'requests/client';

const client = new Client({ basePath: '/users/two_factor_authentication_sms' });

export const createTwoFactorAuthenticationSmsRequest = (data) => {
  return client.create({data});
};
